import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useLoadingCheck() {
  const store = useStore();
  const isLoading = computed(() => store.state.loader.isLoading);
  const loadingTabindex = computed(() => {
    if (isLoading.value === true) {
      return '-1';
    }
    return null;
  });

  function loadingPrevent(event: Event) {
    if (isLoading.value) {
      event.preventDefault();
    }
  }

  return {
    loadingPrevent,
    loadingTabindex,
  };
}
